import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';
import type { TFilterNavigationState } from './types';

const state: TFilterNavigationState = {
  savedFilters: {},
  pendingTransfer: null,
  lastNavigationType: null,
  routeHistory: [],
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
